import type { ContentTextrequirements } from '@/kontent/content-types/content_textrequirements'
import type { IPropWithClassName } from '@/types'
import type { RichtextSectionProps } from '.'
import RichText from '../RichText'

export default function ContentTextrequirementsComponent({
	linkedItem,
	mappings,
	linkedItems,
	currentPath,
	resolveFootnotesLink,
	className,
}: RichtextSectionProps<ContentTextrequirements> & IPropWithClassName) {
	return (
		<RichText
			className={className}
			currentPath={currentPath}
			richTextElement={linkedItem.elements.content}
			mappings={mappings}
			linkedItems={linkedItems}
			resolveFootnotesLink={resolveFootnotesLink}
		/>
	)
}
